import { SendingStatusItem } from './sendingstatusitem';

export class SendingStatus {

  active: boolean;
  error: boolean;
  errorMessage: string;
  done: boolean;
  answers: SendingStatusItem;
  files: SendingStatusItem;
  finishing: SendingStatusItem;

  constructor() {
    this.active = false;
    this.error = false;
    this.errorMessage = null;
    this.done = false;
    this.answers = new SendingStatusItem();
    this.files = new SendingStatusItem();
    this.finishing = new SendingStatusItem();
  }

}


// WEBPACK FOOTER //
// ./src/models/sendingstatus.ts